"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eddsaKeyGenerationMessage = exports.eddsaPrimeFieldMod = void 0;
// Field used for EdDSA signatures.
exports.eddsaPrimeFieldMod = '2736030358979909402780800718157159386076813972158567259200215660948447373040';
// String message used to derive an EdDSA keypair from an Ethereum signature
exports.eddsaKeyGenerationMessage = 'Signing this message generates your EdDSA private key. Only do this on pages you trust to manage your zkCertificates.';
